import { css } from "@emotion/react";
import { BG_MAIN } from "assets/Common";
import ListBackground from "assets/temporary/images/bg_announcement.jpg";
import { theme } from "styles/theme";
export const DetailAnnouncementStyle = {
  modalContainer: () => css`
    .ant-modal-content {
      border-radius: 12px !important;
      overflow: hidden;
      background-color: ${theme.colors.black100} !important;
      padding: 0px !important;
      border: 1px solid ${theme.borders.tertiary};
    }
  `,
  container: () => css``,
  header: () => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    flex-direction: row;
    padding-left: 16px;
    padding-right: 16px;
    background-image: url(${BG_MAIN});
    backface-visibility: initial;
    height: 75px;
    background-size: cover;
    span {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      text-align: center;
      color: ${theme.colors.darkGreen};
    }
  `,
  buttonClose: () => css`
    width: 24px;
    height: 24px;
    border: 0px;
    background-color: transparent;

    img {
      width: 24px;
      height: 24px;
    }
  `,
  itemAnnouncement: () => css`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 24px 32px;
  `,
  itemIcon: () => css`
    margin: 0px 6px;
    position: relative;
  `,
  itemContent: () => css`
    margin-left: 8px;
    p:nth-of-type(1) {
      font-weight: 700;
      font-size: 18px;
      line-height: 24px;
      color: ${theme.colors.darkGreen};
    }
    p:nth-of-type(2) {
      font-weight: 500;
      font-size: 11px;
      line-height: 18px;
      color: #636369;
    }
    p:nth-of-type(3) {
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      color: ${theme.colors.lightText};
      margin-top: 4px;
      padding-right: 8px;
    }
  `,
};
